import { useContext } from 'react';
import { RouterContext } from 'wrapperComponents/BrowserRouter';

// eslint-disable-next-line import/prefer-default-export
export const useRouter = () => {
  return useContext(RouterContext);
};
